export default __webpack_public_path__ + "static/media/H0003.5f3b05a1.png";